export const theme = {
  colors: {
    primaryColor: '#0A1128',
    secondaryColor: '#dc143c',
    white: '#fff',
    mediumGray: '#DDDDDD',
  },

  bgUrls: {
    rainbowBg:
      'https://res.cloudinary.com/dscztnlqq/image/upload/v1627738483/light_Bg_bd6b3b240c.svg',
    snowBg:
      'https://res.cloudinary.com/dscztnlqq/image/upload/v1627739870/snow_e4f6e112ae.svg',
  },

  font: {
    family: {
      default: "'Open Sans', sans-serif",
      secondary: "'Montserrat', sans-serif",
    },
    sizes: {
      xsmall: '8rem',
      small: '1.6rem',
      medium: '2.4rem',
      large: '3.2rem',
      xlarge: '4.0rem',
      xxlarge: '4.8rem',
      huge: '5.6rem',
      xhuge: '6.4rem',
    },
  },

  media: {
    lteMedium: '(max-width: 768px)',
  },
  spacings: {
    xsmall: '8rem',
    small: '1.6rem',
    medium: '2.4rem',
    large: '3.2rem',
    xlarge: '4.0rem',
    xxlarge: '4.8rem',
    huge: '5.6rem',
    xhuge: '6.4rem',
  },
};
